
export type UIUserInterfaceSizeClass =
  | 'unspecified'
  | 'compact'
  | 'regular';

/** Min: iOS 12.0 */
export type UIUserInterfaceStyle =
  | 'unspecified'
  | 'light'
  | 'dark';

export type UIUserInterfaceLevel =
  | 'unspecified'
  | 'base'
  | 'elevated';

export type UIInterfaceOrientation =
  | 'unknown'
  | 'portrait'
  | 'portraitUpsideDown'
  | 'landscapeLeft'
  | 'landscapeRight';

export type UIUserInterfaceActiveAppearance = 
  | 'unspecified'
  | 'inactive'
  | 'active';

export type UITraitEnvironmentLayoutDirection =
  | 'unspecified'
  | 'leftToRight'
  | 'rightToLeft';